import { Box } from '@mui/material';
import { LeftDrawer } from './LeftDrawer';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { SubMenuContext } from '../Contexts';
import { LoggedInFooter } from '../Footers';
import { RequireSubscription } from '../RequireAuth/RequireAuth';

export const AppContainer = ({ children, noSidebar = false }) => {
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);
    const [subMenu, setSubMenu] = useState(null);
    const [passthruDrawerOpenState, setPassthruDrawerOpenState] = useState(false);

    return (
        <SubMenuContext.Provider value={{ subMenu, setSubMenu, passthruDrawerOpenState, setPassthruDrawerOpenState }}>
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw'}}>
                <Box sx={{
                    display: 'flex', width: '100%', height: '100%', minHeight: 0,
                    pt: "64px",
                }}>
                    {!noSidebar && (
                        <RequireSubscription group="sg" noRedirect>
                            <LeftDrawer sx={{ display: { xs: 'none', md: 'block' } }} />
                        </RequireSubscription>
                    )}
                    {children}
                </Box>
                {authStatus === 'authenticated' && <LoggedInFooter/> }
            </Box>
        </SubMenuContext.Provider>
    );
};